import store from '@/store';

export function countryHasProviders() {
  return !!store.getters['merchant/getActiveProvidersList'].length;
}
